import { useEffect, MutableRefObject } from "react";

const useOnClickOutside = (
  ref: MutableRefObject<HTMLElement>,
  handler: () => void
) => {
  useEffect(() => {
    const listener = (event: MouseEvent) => {
      const { target } = event;
      const isChild = target instanceof Node && ref.current.contains(target);

      if (ref.current && !isChild) {
        handler();
      }
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
};

export default useOnClickOutside;
